import { render, staticRenderFns } from "./communication-tags.vue?vue&type=template&id=eef9b34c"
import script from "./communication-tags.vue?vue&type=script&lang=js"
export * from "./communication-tags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports